import { Navigate } from "react-router-dom";


function PrivateRoute({ children }) {
    const login = JSON.parse(localStorage.getItem("login")) || "";

    if(login){
        return children
    }else{
        <Navigate to="/login" />
    }
}

export default PrivateRoute;